/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { forwardRef } from "react";
import MUITextField, { TextFieldProps } from "@mui/material/TextField";

/**
 * Wrapper component for Material-UI TextField.
 * Standard text input field with label and validation.
 * 
 * @param props - TextField properties (value, onChange, label, variant, etc.)
 * @returns Text input field component
 */
const TextField = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  return <MUITextField {...props} inputRef={ref} />;
});

export default TextField;
